module.exports = __webpack_public_path__ + "static/media/icon2.7cf69a70.jpeg";